import { displaySuccessFeedbackMessage, fetchFormValues, getTranslation } from './utilities';

jQuery(function($)
{
    let api = orion.api.shippingAddresses;
    let wrapper = document.querySelector('.js-shipping-address-edit');
    let newTrigger = document.querySelector('.js-shipping-address-new-trigger');
    let form = document.querySelector('.js-shipping-address-edit-form');
    let submit = document.querySelector('button[name=\'submitShippingAddress\']');
    let orderFormShippingAddressId = document.querySelector('#orderFormShippingAddressId');
    let $addressList = $('div.address-list ul.inner-list-container');
    let $overlay = $('#overlay-address-new-edit');
    let $accountAddressNewEditUrl = getTranslation('accountAddressNewEditUrl');
    let initialFormValues;
    let allShippingAddresses;
    let $addressDeleteOverlay = $('#overlay-delete-address');
    let $deleteForm = $('form', $addressDeleteOverlay);
    let urlPath = $deleteForm.attr('action');

    if (wrapper === null)
    {
        return;
    }

    let fetchedFormValues = fetchFormValues(form);
    initialFormValues = convertApiDataToFormData(fetchedFormValues);

    function init()
    {
        let loadingIndicator = wrapper.querySelector('.loading-indicator');

        loadingIndicator.classList.remove('loading-indicator--hidden');

        api.read().done(function(data)
        {
            allShippingAddresses = data.shippingAddresses || {};
            updateList(data);
            loadingIndicator.classList.add('loading-indicator--hidden');
            initEvents();
        })
            .fail(function(xhr, status, error)
            {
                loadingIndicator.classList.add('loading-indicator--hidden');

                console.log(error);
            });
    }

    function initEvents()
    {
        let editTriggers = document.querySelectorAll('.js-shipping-address-edit-trigger');
        editTriggers.forEach((trigger) =>
        {
            trigger.addEventListener('click', handleClickEditTrigger);
        });

        $('.js-address-entry .overlay-trigger').on('click', handleClickDeleteAddressEntry);

        newTrigger.addEventListener('click', handleClickNewTrigger);

        submit.addEventListener('click', handleClickSubmit);
    }

    function convertApiDataToFormData(apiData)
    {
        let shippingAddress = apiData;
        if (apiData.shippingAddress !== undefined)
        {
            ({ shippingAddress } = apiData);
        }

        return {
            'shippingAddress[additionalLine]': shippingAddress.additionalLine,
            'shippingAddress[addressId]': shippingAddress.addressId,
            'shippingAddress[addressType]': shippingAddress.addressType,
            'shippingAddress[city]': shippingAddress.city,
            'shippingAddress[countryCode]': shippingAddress.countryCode,
            'shippingAddress[firstName]': shippingAddress.firstName,
            'shippingAddress[lastName]': shippingAddress.lastName,
            'shippingAddress[street]': shippingAddress.street,
            'shippingAddress[zipcode]': shippingAddress.zipcode,
        };
    }

    function getShippingAddressByAddressId(shippingAddressesJson, addressId)
    {
        for (const [, shippingAddressJson] of Object.entries(shippingAddressesJson))
        {
            if (typeof shippingAddressJson.addressId !== 'undefined' && shippingAddressJson.addressId == addressId)
            {
                return shippingAddressJson;
            }
        }

        return {};
    }

    function populateForm(formElement, data)
    {
        var formElements = formElement.elements;

        [...formElements].forEach((element) =>
        {
            if (element.matches('[type=radio]') || element.matches('[type=checkbox]'))
            {
                let combinedName = element.name + '-' + element.value;

                if (typeof data[combinedName] !== 'undefined')
                {
                    element.checked = data[combinedName];
                    element.dispatchEvent(new Event('change'));
                }
            }
            else
            {
                if (typeof data[element.name] !== 'undefined')
                {
                    element.value = data[element.name];
                    element.dispatchEvent(new Event('change'));
                }
            }
        });
    }

    function handleClickEditTrigger(event)
    {
        event.preventDefault();

        let { addressId } = this.dataset;

        let shippingAddress = getShippingAddressByAddressId(allShippingAddresses, addressId);

        let convertedShippingAddressData = convertApiDataToFormData(shippingAddress);

        populateForm(form, convertedShippingAddressData);
    }

    function handleClickDeleteAddressEntry()
    {
        var $this = $(this);
        var $addressEntry = $this.parents('.js-address-entry').eq(0);

        var addressId = $addressEntry.data('address-id');
        var urlParam = { id: addressId };

        var urlObject = new URI(urlPath);

        urlObject.addSearch(urlParam);

        $deleteForm.attr('action', urlObject.href());
    }

    function handleClickNewTrigger()
    {
        populateForm(form, initialFormValues);
    }

    function handleClickSubmit(event)
    {
        event.preventDefault();

        $(form).trigger(orion.constants.EventFormValidate);

        let errors = $(form).find('div.error');

        if (!errors.length)
        {
            var $data = {
                'shippingMode': 'Shipping',
                'shippingAddress': {
                    'addressId': $('input[name=\'shippingAddress[addressId]\']').val(),
                    'addressType': $('input[name=\'shippingAddress[addressType]\']').val(),
                    'firstName': $('input[name=\'shippingAddress[firstName]\']').val(),
                    'lastName': $('input[name=\'shippingAddress[lastName]\']').val(),
                    'street': $('input[name=\'shippingAddress[street]\']').val(),
                    'zipcode': $('input[name=\'shippingAddress[zipcode]\']').val(),
                    'city': $('input[name=\'shippingAddress[city]\']').val(),
                    'countryCode': $('select[name=\'shippingAddress[countryCode]\']').val(),
                    'additionalLine': $('input[name=\'shippingAddress[additionalLine]\']').val(),
                    'isDefault': false
                }
            };

            $.ajax('/api-customer-de/shipping-addresses', {
                cache: false,
                headers: {
                    'Accept': 'application/json',
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify($data),
                method: 'POST',
                statusCode: {
                    201: function()
                    {
                        init();
                        hideOverlay();
                        displaySuccessFeedbackMessage(getTranslation('feedback.account.address.new.ok.heading'));
                    },
                    400: function()
                    {
                        console.log('Bad Request - new address could not be created.');
                    },
                    403: function()
                    {
                        console.log('Forbidden. Client must be authenticated and use valid session');
                    }
                }
            });
        }
    }

    function hideOverlay()
    {
        $overlay.addClass('hidden');
        $('body').removeClass('no-scroll focus-active');
    }

    function updateList(data)
    {
        clearShippingAddressList();
        var $defaultId = data['defaultShippingAddressId'];
        var $items = data['shippingAddresses'];

        $.each($items, function(index, value)
        {
            insertShippingAddressEntry( value, $defaultId );
        });

        updateOrderFormShippingAddressId();
    }

    function updateOrderFormShippingAddressId()
    {
        let $addressEntries = $('li.address-entry');

        $addressEntries.each(function()
        {
            if ($(this).hasClass('default'))
            {
                var $form = $(this).parent()
                    .parent();
                var $input = $form.find('input[name=\'addressId\']');

                setOrderFormShippingAddressId($input.val());
                $(submit).removeClass('disabled');
            }
        });
    }

    function setOrderFormShippingAddressId($id)
    {
        $(orderFormShippingAddressId).val($id);
    }

    function clearShippingAddressList()
    {
        $addressList.empty();
    }

    function insertShippingAddressEntry( $address, $defaultId )
    {
        var $default = ($defaultId == $address['addressId']) ? ' default' : '';

        var $html = '<li class=\'' + $default + 'address-entry js-address-entry\''
			+ ' data-address-id=\'' + $address['addressId'] + '\'>'
			+ '<div class=\'address-entry-inner\'>'
			+ '<div>'
			+ '<p class=\'text--bold mb--none-bottom\'><b>' + $address['lastName'] + '</b></p>'
			+ '<p class=\'small mb--none-bottom\'>' + $address['street']
			+ ', ' + $address['zipcode']
			+ ' ' + $address['city']
			+ ', ' + $address['countryCode']
			+ '</p>'
			+ '</div>'
			+ '<div class=\'flex flex-row gap-bp\'>'
            + '<a data-target=\'overlay-delete-address\' class=\'overlay-trigger button secondary\'>'
            + '<i class=\'fa-regular fa-trash-can\'></i></a>'
			+ '<a href=\'' + $accountAddressNewEditUrl + '?addressId=' + $address['addressId'] + '\''
			+ ' data-address-id=\'' + $address['addressId'] + '\''
			+ ' class=\'overlay-trigger button secondary js-shipping-address-edit-trigger\''
			+ ' data-target=\'overlay-address-new-edit\'>'
			+ '<i class=\'fa-regular fa-pencil\'></i>'
			+ '</a>'
			+ '</div>'
			+ '</div>'
			+ '</li>';

        $addressList.append($html);
    }

    init();
});
